<template>
  <div class="login">
    <div class="title">{{ $t('resetYourPassword') }}</div>

    <div class="info">
      {{ $t('resetYourPasswordDescription') }}
    </div>

    <VeeForm v-slot="{ errors }" @submit="register">
      <Transition name="fade">
        <div v-if="error || Object.keys(errors).length > 0" class="error-container">
          <div class="error-icon">!</div>
          <div v-if="error" class="error-text">{{ error }}</div>
          <div v-else-if="errors['email']" class="error-text">{{ $t('errorMessage.emailInvalid') }}</div>
        </div>
      </Transition>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('emailAddress') }}</div>
        </div>

        <Field name="email" rules="required|email" type="text" :placeholder="$t('emailAddress')" />
      </div>

      <button class="study-button main" :class="{ loading: loading }">
        {{ loading ? $t('loading') : $t('forgotPassword.validate') }}
      </button>
    </VeeForm>

    <RouterLink :to="{ name: 'userLogin' }" class="text-button">{{ $t('backToLogin') }}</RouterLink>
  </div>
</template>

<script>
import { Field, Form as VeeForm } from 'vee-validate';

export default {
  components: {
    Field,
    VeeForm,
  },

  data() {
    return {
      error: null,
      loading: false,
    };
  },

  methods: {
    register(values) {
      if (this.loading) return;
      this.loading = true;
      this.error = null;

      setTimeout(() => {
        this.loading = false;
      }, 2000);

      this.$store
        .dispatch('clientRestLink', values.email.replace('+', '%2B'))
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'userForgetCompleted', params: { emailKey: this.email } });
        })
        .catch(e => {
          this.loading = false;
          switch (e.code) {
            default:
              this.error = e.error;
              break;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';
</style>
